module.exports = __webpack_public_path__ + "img/logo.6a5ae9b8.png";